<template>
  <div class="bg-black text-white px-lg-5">
    <h1 class="my-font my-color mt-3 mb-5 my-padding">محصولات کوپابی</h1>
    <div id="what-is">
      <h3 class="my-font my-color mt-3 my-padding">🐝 خمیر شیرین چیست؟</h3>
      <div class="my-padding">
        <p>
          خمیر شیرین یک خوراک آماده و مکمل برای زنبورعسل است که عمدتاً از ترکیبات کربوهیدراتی تشکیل شده و در زمان هایی
          که
          منابع طبیعی مانند شهد گل یا عسل در دسترس نیستند – به ویژه در فصل زمستان – جایگزین مناسبی برای تغذیه کلنی ها به
          شمار می رود.
          <br>
          در گذشته، زنبورداران با ترکیب دستی عسل و شکر، خمیر تهیه می کردند. اما امروزه با بهره گیری از دانش فنی، این
          محصول
          به صورت صنعتی و بهینه تولید می شود. برخلاف شربت های مایع، خمیر شیرین فاقد رطوبت اضافی است و در نتیجه، خطر
          تخمیر
          یا فساد درون کندو را کاهش می دهد.
          به همین دلیل، خمیر شیرین امروزه نه تنها یک خوراک کمکی در فصول بحرانی، بلکه ابزاری حرفه ای در مدیریت کلنی ها
          محسوب می شود.
        </p>
        <div class="img-section">
          <img class="col-12 col-lg-6 mx-auto my-3 " src="/img/product1.jpg" alt="">
        </div>
      </div>
    </div>
    <div id="types">
      <h3 class="my-font my-color mt-3 my-padding">🍯 انواع خوراک زنبورعسل بر اساس شکل ظاهری</h3>
      <div class="my-padding">
        <p>
          خوراک زنبورعسل بر پایه ی حالت فیزیکی و میزان رطوبت، به سه دسته ی اصلی تقسیم می شود:

          <br>
          <b class="my-color">1.خوراک مایع (شربت)</b>
          این نوع شامل محلول آب و شکر یا گلوکز است که بیشتر در بهار و پاییز مورد استفاده قرار می گیرد.
          <br>
          مزایا: تحریک تخم گذاری ملکه، جذب سریع، قیمت اقتصادی
          <br>
          معایب: ریسک تخمیر، احتمال آلودگی، افزایش رطوبت کندو
          <br>

          <b class="my-color">2. خوراک نیمه جامد (نیمه مایع)</b>
          <br>
          خوراک هایی مانند کوپابی با بافتی میان خمیر و ژل، حاوی قندهای هیدرولیز شده اند. این خوراک خوش خوراک، آماده مصرف
          و بدون نیاز به رقیق سازی است.
          <br>
          زمان مصرف مناسب: پاییز، مواقع کمبود شهد طبیعی و اوایل بهار
          <br>
        </p>
        <div class="img-section">
          <img class="col-12 col-lg-6 mx-auto my-3 " src="/img/product2.jpg" alt="">
        </div>
        <p>
          <b class="my-color"> 3. خوراک جامد (خمیر شیرین / فوندانت)</b>
          <br>
          از ترکیب قندهای جامد ساخته می شود و به صورت قالبی در اختیار زنبوردار قرار می گیرد.
          <br>
          مزیت: ماندگاری بالا در زمستان.
          <br>
          نکته: برای مصرف بهتر، دمای کندو باید مناسب باشد.


        </p>
      </div>
    </div>
    <div class="row p-0 m-0 justify-content-lg-center">
      <div class="col-lg-6 d-flex my-padding font-size-12" style="background: url('/img/pback.svg')right top no-repeat;
      background-size: 100%; margin-top: -16px; padding-top: 50px; padding-bottom: 100px">
        <div class=" text-center pt-3" style="width: 30% !important">
          <img src="/img/vectorright.png" class="w-100 mb-3" alt="">
          <p>بدون زحمت آماده سازی</p>
        </div>
        <div class=" text-center p-0 m-0" style="width: 40% !important">
          <img src="/img/p2.png" class="w-100" alt="">
        </div>
        <div class=" text-center p-0 m-0" style="width: 30% !important">
          <div class="d-grid h-100 pb-3">
            <div class="align-self-end">
              <p class="mb-2">عدم استفاده از مواد تراریخته در ترکیبات محصول</p>
              <img src="/img/vectorleft.png" class="w-100" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>


    <div id="copabee">
      <h3 class="my-font my-color mt-3 my-padding">🌿 معرفی محصول:</h3>
      <div class="my-padding">
        <p>
          <b class="my-color">کوپابی (Copabee)</b>
          <br>
          کوپابی یک خوراک نیمه جامد آماده مصرف برای زنبور عسل است که با هدف تغذیه کمکی کلنی ها در فصل هایی با کمبود
          منابع طبیعی طراحی شده است. این محصول از ترکیب قندهای طبیعی نظیر گلوکز، فروکتوز و ساکارز تولید می شود و در برخی
          نسخه ها با مواد مغذی مانند ویتامین ها، پروتئین ها و املاح معدنی غنی سازی می گردد.
          <br>
          کوپابی یک خوراک نیمه جامد و آماده مصرف برای زنبورعسل است که با هدف تغذیه کمکی کلنی ها در زمان کمبود منابع
          طبیعی طراحی شده است. این محصول از ترکیب قندهای طبیعی مانند گلوکز، فروکتوز و ساکارز تهیه می شود و در نمونه های
          آزمایشگاهی با مواد مغذی نظیر ویتامین ها، پروتئین ها و املاح معدنی غنی سازی شده است.
        </p>
        <div class="img-section">
          <img class="col-12 col-lg-6 mx-auto my-3 " src="/img/product3.jpg" alt="">
        </div>
        <p>
          ✅ چرا کوپابی را انتخاب کنیم؟
          <br>
          حاوی قندهای ساده و بافت نیمه جامد و در نتیجه خوش خوراک برای زنبورعسل
          <br>
          کاملاً آماده مصرف؛ بدون نیاز به افزودن آب یا رقیق سازی
          <br>
          ماندگاری بالا و نگهداری آسان حتی در دمای محیط
          <br>
          جلوگیری از استرس تغذیه ای کلنی در شرایط بحرانی
          <br>
          مناسب برای پاییز، زمان کمبود شهد و اوایل بهار
          <br>
          بدون ایجاد رطوبت یا خطر تخمیر داخل کندو
          <br>
          بدون بر جای گذاشتن ذرات قندی در کندو پس از مصرف
          <br>
          جلوگیری از تحریک رفتار غارت در زنبورستان
          <br>
          عاری از ترکیبات شیمیایی سمی(HMF)
          <br>
          کاهش استرس زنبور عسل
          <br>
          بافت استاندارد، بدون ایجاد تلفات
        </p>
      </div>
    </div>
    <div id="usage">
      <h3 class="my-font my-color mt-3 my-padding">🧃 روش مصرف صحیح خوراک زنبورعسل کوپابی</h3>
      <div class="my-padding">
        <p>
          1_ ابتدا با استفاده از یک شیء تیز و تمیز، قسمت مشخص شده روی بسته را برش دهید.
          <br>
          2_ محصول را بر روی قاب های کندو قرار دهید.
        </p>
        <div class="img-section">
          <img class="col-12 col-lg-3 mx-auto my-3 " src="/img/product4.png"
               style="background-color: white; border: 8px solid gold; overflow: hidden; border-radius: 20px" alt="">
        </div>
        <p> به وسیله دوربین گوشی همراه خود ، QR کد را اسکن و کلیپ نحوه صحیح مصرف محصول را مشاهده نمائید .</p>
        <div class="img-section">
          <img class="col-12 col-lg-6 mx-auto my-3 " src="/img/product5.jpg" alt="">
        </div>
      </div>
    </div>
    <div id="documents">
      <h3 class="my-font my-color mt-3 my-padding">📚 مستندات علمی و آزمایشگاهی
      </h3>
      <div class="row my-padding">
        <div class="col-lg-3">
          <p> 📄 آنالیز ترکیب خوراک</p>
          <a href="/img/product6.png" class="img-link">
            <img class=" mx-auto w-100 my-3" src="/img/product6.png" alt="">
          </a>
        </div>
        <div class="col-lg-6 row">
          <p>🧪ایمنی و کنترل کیفی</p>
          <div class="col-lg-6">
            <a href="/img/product7.png" class="img-link d-block w-100">
              <img class="mx-auto w-100 my-3" src="/img/product7.png" alt="">
            </a>
          </div>
          <div class="col-lg-6">
            <a href="/img/product8.png" class="img-link d-block w-100">
              <img class="mx-auto w-100 my-3" src="/img/product8.png" alt="">
            </a>
          </div>
        </div>

        <div class="col-lg-3">
          <p>✅ مجوزها و تأییدیه ها</p>
          <a href="/img/product9.png" class="img-link">
            <img class=" mx-auto w-100 my-3" src="/img/product9.png" alt="">
          </a>
        </div>
        <div class="col-lg-3">
          <p>📊 نتایج مطالعات میدانی</p>
          <a class="text-info mb-3" target="_blank" href="/file/نتایج_تحقیقات_میدانی.pdf">دانلود فایل pdf</a>
        </div>


      </div>
    </div>
    <div id="basket">
      <h3 class="my-font my-color mt-3 my-padding">📦 سبد محصولات کوپابی</h3>
      <div class="my-padding">
        <p>
          خمیر شیرین یک خوراک آماده و مکمل برای زنبورعسل است که عمدتاً از ترکیبات کربوهیدراتی تشکیل شده و در زمان هایی
          که
          منابع طبیعی مانند شهد گل یا عسل در دسترس نیستند – به ویژه در فصل زمستان – جایگزین مناسبی برای تغذیه کلنی ها به
          شمار می رود.
          <br>
          در گذشته، زنبورداران با ترکیب دستی عسل و شکر، خمیر تهیه می کردند. اما امروزه با بهره گیری از دانش فنی، این
          محصول
          به صورت صنعتی و بهینه تولید می شود. برخلاف شربت های مایع، خمیر شیرین فاقد رطوبت اضافی است و در نتیجه، خطر
          تخمیر
          یا فساد درون کندو را کاهش می دهد.
          به همین دلیل، خمیر شیرین امروزه نه تنها یک خوراک کمکی در فصول بحرانی، بلکه ابزاری حرفه ای در مدیریت کلنی ها
          محسوب می شود.
        </p>
      </div>
      <div class="row text-lg-center justify-content-lg-center">
        <p class="text-lg-center mt-lg-3">خوراک ساده زنبور عسل</p>
        <div class="col-12 col-lg-3  ">
          <img class=" mx-auto my-3 " src="/img/product10.jpg" alt="">
          <p class="text-center">
            حجم 1000 گرم
            <br>
            مناسب کلنی های قوی و بیشتر از 5 قاب
          </p>
        </div>
        <div class="col-12 col-lg-3 ">
          <img class="mx-auto my-3 " src="/img/product11.jpg" alt="">
          <p class="text-center">
            حجم 590 گرم
            <br>
            مناسب برای کندوهای ضعیف ،بر گرفته شده و کمتر از 5 قاب
          </p>
        </div>

      </div>
    </div>


    <div id="faq">
      <h3 class="my-font my-color mt-3 my-padding">❓ پرسش های پرتکرار</h3>
      <div class="my-padding">
        <b class="my-color">۱. خوراک نیمه جامد کوپابی چه تفاوتی با فوندانت یا خوراک های دستی دارد؟ </b>
        خوراک نیمه جامد کوپابی با ترکیب صنعتی، بافت نرم و فرمولاسیون متعادل، متناسب با نیازهای زیستی زنبور عسل طراحی شده
        است. برخلاف فوندانت که بافتی خشک و سفت دارد و در سرما یا کم آبی ممکن است به خوبی مصرف نشود، کوپابی حتی در دمای
        معمول کندو هم به راحتی توسط زنبور تغذیه می شود و تغذیه ای ایمن و مؤثر را در شرایط بحرانی برای کلنی فراهم می کند.
        <br>

        <b class="my-color">۲. در چه دمایی باید از این محصول استفاده کرد؟ </b>
        خوراک نیمه جامد کوپابی در بازه دمایی ۱۰ تا ۴۰ درجه سانتی گراد قابل مصرف است. چه در هوای خنک بهاری و چه در گرمای
        تابستانی، زنبور بدون مشکل می تواند از آن تغذیه کند؛ فقط لازم است
        <a class="text-info" @click="scroll('usage')">دستورالعمل مصرف</a>


        به درستی رعایت شود تا بهره وری
        تغذیه به حداکثر برسد.
        <br>
        <b class="my-color">۳. آیا خوراک کوپابی برای تمام نژادهای زنبور عسل مناسب است؟ </b>
        بله. فرمولاسیون کوپابی بر اساس نیازهای مشترک تغذیه ای در تمام نژادهای زنبور عسل طراحی شده است. چه نژادهای بومی
        مقاوم و چه نژادهای پر تولید و حساس، همگی می توانند بدون مشکل از این خوراک استفاده کنند.
        <br>
        <b class="my-color">۴. آیا می توان کوپابی را با مکمل های دیگر ترکیب کرد؟ </b>
        بله، کوپابی به دلیل بافت نیمه جامد و طبیعی اش، پایه ای مناسب برای افزودن مکمل های تغذیه ای استاندارد زنبورعسل
        است. فقط باید اطمینان حاصل شود که مکمل ها از منابع مجاز تهیه شده و ترکیب آن ها با آگاهی و دقت انجام شود.
        <br>
        <b class="my-color">۵. زنبورها چه مدت پس از قرار دادن کوپابی، شروع به مصرف آن می کنند؟ </b>
        در همان ساعت اول پس از قرار دادن کوپابی، معمولاً توده ای از زنبورها روی محصول دیده می شود که مشغول مصرف آن
        هستند. این نشان دهنده ی خوش خوراکی و پذیرش سریع محصول توسط کلنی است.
        <br>

        <b class="my-color">۶. آیا استفاده از کوپابی باعث تحریک غارت می شود؟ </b>
        خیر. کوپابی به دلیل بافت نیمه جامد و بدون بوی تند، برخلاف شربت های مایع، خطر تحریک رفتار غارت را به طور
        قابل توجهی کاهش می دهد.
        <br>

        <b class="my-color">۷. چطور باید خوراک کوپابی را در کندو قرار داد؟ </b>
        کافی است با یک ابزار تیز و تمیز، قسمت مشخص شده روی بسته را برش دهید و آن را مستقیماً روی قاب های کندو بگذارید.
        این روش ساده و بهداشتی، مصرف بهینه خوراک را تضمین می کند.

        <a class="text-info" @click="scroll('usage')">دستورالعمل نحوه مصرف خوراک زنبور عسل کوپابی</a>

        <br>


        <b class="my-color">۸. ماندگاری کوپابی چقدر است و چطور باید نگهداری شود؟ </b>
        این محصول نیازی به نگهداری در سردخانه یا یخچال ندارد، اما باید در محیطی خشک، خنک و دور از تابش مستقیم خورشید
        نگهداری شود تا کیفیت و ماندگاری آن حفظ شود.
        <br>

        <b class="my-color">۹. آیا کوپابی روی کیفیت عسل تأثیر می گذارد؟ </b>
        خیر. کوپابی در فصولی استفاده می شود که خارج از فصل تولید عسل هستند. زنبورها این خوراک را برای مصرف مستقیم به کار
        می برند، نه ذخیره سازی، بنابراین اثری بر کیفیت یا خلوص عسل نهایی ندارد.


        <b class="my-color">۱۰. آیا محصول دارای مجوز و آزمایش های کیفی است؟ </b>
        بله. خوراک کوپابی تحت کنترل کیفی دقیق تولید می شود و دارای مجوز رسمی، آنالیز آزمایشگاهی، و مستندات ایمنی و
        مطالعات میدانی است. این اطلاعات در بخش

        <a class="text-info" @click="scroll('documents')">مستندات علمی و آزمایشگاهی</a> <!-- scroll -->
        قابل مشاهده و دانلود هستند.
        <br>


        <a class="text-info" @click="scroll('contact')">سوال دارید؟ از ما بپرسید</a>
        <br>
        در ادامه بخوانید
        <br>
        <a class="text-info" href="/faq">سوالات متداول</a>
        زنبورداران از کوپابی چیست؟


        از کجا خرید کنیم؟
        جهت خرید از کوپابی از طریق

        <a class="text-info" @click="scroll('contact')">شماره های ارتباطی واحد فروش</a>
        اقدام کنید.

      </div>
    </div>


    <div class="row my-padding py-5 justify-content-center">
      <div class="col-lg-7 my-bg rounded-3 p-5 text-black text-center position-relative">
        <img src="/img/b2.png" width="150px" class="position-absolute " style="left:10px; top: 30px" alt="">
        <h5 class="text-center">ثبت نام جهت خرید از کوپابی</h5>
        <router-link to="/register" class="btn-black mt-5" style="padding-top: 12px">ایجاد حساب کاربری</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {onMounted} from "vue";

export default {
  name: "Product",
  setup() {
    const scroll = (id) => {
      document.getElementById(id)?.scrollIntoView();
    }
    onMounted(() => {
      if (localStorage.getItem('scroll')) {
        scroll(localStorage.getItem('scroll'));
        localStorage.removeItem('scroll')
      }
    })
    return {
      scroll,
    }
  }
}
</script>

<style scoped>
p {
  text-align: justify-all !important;
}

b {
  display: block;
  margin-top: 15px;
  margin-bottom: 5px;
}

a {
  cursor: pointer;
}
</style>